module.exports = __webpack_public_path__ + "img/fahuo.7387f92f.png";